export const LOAD_CHATS = 'LOAD_CHATS';
export const LOAD_CHATS_SUCCESS = 'LOAD_CHATS_SUCCESS';
export const LOAD_CHATS_ERROR = 'LOAD_CHATS_ERROR';

export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED';

export const SEND_MESSAGE = 'SEND_MESSAGE';

export const OPEN_CHAT = 'OPEN_CHAT';
